<template>
    <div id="game-component" ref="game-component">
        <audio id="jump" :src="$url + 'audio/jump.mp3'"></audio>
        <audio id="coleta" :src="$url + 'audio/coleta.mp3'"></audio>
        <audio id="trilha" loop>
            <source :src="$url + 'audio/trilha_0.mp3'" type="audio/mpeg">
            Your browser does not support the audio element.
        </audio>
        <canvas id="game" ref="game" v-on:click="audioTrilha"></canvas>
        <MobileControllerComponent v-if="mobile_controller"></MobileControllerComponent>

        <!-- <button v-on:click="checkPosition" style="position:absolute;z-index:999999; left:0; top:0">checkPosition</button> -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import * as BABYLON from 'babylonjs';
    import 'babylonjs-loaders';
    import * as Materials from 'babylonjs-materials';
    import { CharacterController } from "babylonjs-charactercontroller";
    import { isMobile } from 'mobile-device-detect';
    import 'pepjs';
    import axios from "axios";
    import MobileControllerComponent from '@/components/MobileControllerComponent';

    export default {
        name: "GameComponent",
        components: {
            MobileControllerComponent
        },
        data() {
            return {
                camera     : null,
                canvas     : null,
                cc         : null,
                count      : 0,
                engine     : null,
                me         : null,
                players    : [],
                players_ani: [],
                scene      : null,
                skeleton   : null,
                //itens
                itens_listener: [],
                audio_started: false,
                jump_active:false,
                //
                itens_meshes     : null,
                total_itens      : 30,
                itens_unicos     : 10,
                second_level     : 30,
                itens_preenchidos: [],
                p_0: 0,
                p_1: 0,
                count_timer: 0,
                timer: null,
                mobile_controller: false,

                fixed_item: false,
            }
        },
        computed: {
            ...mapGetters(['token', 'logged', 'id', 'name', 'email', 'points', 'player', 'avatar', 'mobile', 'item', 'itens', 'itens_ref', 'itens_fase_2', 'itens_pos', 'info_started', 'itens_count_day'])
        },
        methods: {


            getActualPosition(e) {
                //console.log(this.me.position.x, this.me.position.y, this.me.position.z);

                e.preventDefault();
            },
            checkPosition(e) {
                if (this.itens_pos[this.p_0][this.p_1]) {
                    //console.log(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                    console.log(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                    this.me.position = new BABYLON.Vector3(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                    this.p_1++;
                } else {
                    this.p_0++;
                    this.p_1 = 0;
                    //console.log(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                    console.log(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                    this.me.position = new BABYLON.Vector3(this.itens_pos[this.p_0][this.p_1][0], this.itens_pos[this.p_0][this.p_1][1], this.itens_pos[this.p_0][this.p_1][2]);
                }
                e.preventDefault();
            },

            audioTrilha() {
                if (!this.audio_started) {
                    this.audio_started = true;
                    document.getElementById('trilha').play();
                }
            },


            
            ...mapActions(['update_profile', 'increment', 'update_item', 'update_mobile', 'update_info_started', 'update_itens_count_day']),
            resize() {
                this.engine.resize();
            },
            listener() {
                this.scene.render();


                
                



                this.count++;
                
                if (!this.$parent.view_item) {
                    //if ((this.count % 25) === 0) {
                        
                        //----- colisão coleta -----//
                        for (let o = 0; o < this.itens_listener.length; o++) {
                            if (this.itens_listener[o] && this.me.intersectsMesh(this.itens_listener[o], false)) {

                                document.getElementById('coleta').play();
                                this.$parent.view_item = true;
                                let index = this.itens_ref.indexOf(this.itens_listener[o].name);

                                //console.log( this.itens_count_day, this.second_level);
                                

                                this.update_itens_count_day(this.itens_count_day + 1);
                                this.$parent.savePoints(index, this.itens_count_day > this.second_level ? 20 : 10);
                                this.update_item(index);


                                //console.log('(this.total_itens - this.itens_count_day) -> ', this.total_itens, this.itens_count_day, this.second_level, (this.total_itens - this.itens_count_day));

                                //
                                if (!this.itens_preenchidos[index])
                                    this.itens_preenchidos[index] = 1;
                                else
                                    this.itens_preenchidos[index]++;
                                //

                                //console.log('this.itens_preenchidos 0 -> ', this.itens_preenchidos);


                                if (this.itens_count_day == this.second_level) {
                                    this.total_itens = 50;
                                    this.itensAdicionais();
                                }
                                this.itens_listener[o].dispose();
                                this.scene.removeMesh(this.itens_listener[o]);
                                this.itens_listener[o] = null;
                                //this.itens_listener.splice(o, 1);
                            }
                        }
                        //----- -----//
                    //}
                }

                if ((this.count % 50) === 0) {


                    
                    /*try
                    {
                        console.log(this.me.position.x, this.me.position.y, this.me.position.z, this.camera.position.x, this.camera.position.y, this.camera.position.z);
                    }
                    catch(e) { e;}*/
                    
                    //console.log(this.$parent.$refs['multiplayer'].ws);
                    /*try {
                        this.$parent.$refs['multiplayer'].ws.send(JSON.stringify({ type:'refresh', id_user: this.id, player: this.player, x:this.me.position.x, y:this.me.position.y, z:this.me.position.z, rotation:this.me.rotation, frame:this.skeleton._animatables[0].animations[0]._runtimeAnimations[0].currentFrame }));
                    } catch(e) { e; }
                    this.count = 0;*/

                    //testes
                    //ok
                    //console.log(this.scene.animatables[0].getAnimations()[0].currentFrame);
                    //this.skeleton._animatables[0].animations[0]._runtimeAnimations[0].currentFrame
                    //get animations(ok)
                    //console.log(this.me.position.x, this.me.position.y, this.me.position.z);
                    //
                
                    
                    //console.log(this.me.position);
                }

                
            },
            updateMyPlayer(player_id , players_) {
                this.me.id = player_id;
                this.addPlayer(players_);
            },



            //----- others_players -----//
            addPlayer(players_) {
                let root_ = this;
                for (let o = 0; o < players_.length; o++) {
                    if (String(players_[o]) !== String(this.player)) {
                        if (this.players.indexOf(String(players_[o])) === -1) {
                            BABYLON.SceneLoader.ImportMesh("", this.$url + "player/", "Vincent-backFacing.babylon", this.scene, function (meshes, particleSystems, skeletons) {
                                let p                                  = meshes[0];
                                root_.players[String(players_[o])]     = p;
                                root_.players_ani[String(players_[o])] = "idle";
                                let skeleton                           = skeletons[0];
                                p.id                                   = String(players_[o]);
                                p.skeleton                             = skeleton;
                                p.position                             = new BABYLON.Vector3(8, 0.5, -3);
                                p.checkCollisions                      = false;
                                p.ellipsoid                            = new BABYLON.Vector3(0.5, 1, 0.5);
                                p.ellipsoidOffset                      = new BABYLON.Vector3(0, 1, 0);
                                root_.scene.beginAnimation(skeleton, skeleton.getAnimationRange("idle").from, skeleton.getAnimationRange("idle").to, true);
                            });
                        }
                    }
                }
            },
            removePlayer(player_id) {
                this.players[player_id].dispose();
            },
            getNearestNumber(a, n) {
                if ((l = a.length) < 2)
                    return l - 1;
                for (var l, p = Math.abs(a[--l] - n); l--;)
                    if (p < (p = Math.abs(a[l] - n)))
                        break;
                return l + 1;
            },
            refreshPlayer(data) {
                if (data.id_user !== this.id) {
                    this.players[data.player].position = new BABYLON.Vector3(data.x, data.y, data.z);
                    this.players[data.player].rotation = new BABYLON.Vector3(data.rotation.x , data.rotation.y, data.rotation.z);

                    let ani         = ["fall", "fall", "idle", "idle", "idleJump", "idleJump", "idleJump2", "idleJump2", "run", "run", "runJump", "runJump", "from", "from", "slideBack", "slideBack", "strafeLeft", "strafeLeft", "strafeRight", "strafeRight", "turnLeft", "turnLeft", "turnRight", "turnRight", "walk", "walk", "walkBack", "walkBack", "z", "z"];
                    let frames      = [0, 17, 30, 75, 80, 121, 130, 131, 140, 161, 170, 202, 210, 239, 250, 255, 260, 304, 310, 354, 360, 382, 390, 412, 420, 455, 460, 486, 500, 501];
                    let current_ani = ani[this.getNearestNumber(frames, Math.ceil(data.frame))];

                    if (this.players_ani[String(data.player)] != current_ani) {
                        this.players_ani[String(data.player)] = current_ani;
                        this.scene.beginAnimation(this.players[data.player].skeleton, this.players[data.player].skeleton.getAnimationRange(current_ani).from, this.players[data.player].skeleton.getAnimationRange(current_ani).to, true);
                    }
                }
            },
            //----- \\others_players\\ -----//


            jumpMobile() {
                if (this.cc)
                {
                    this.cc.jump(true);
                    document.getElementById('jump').play();
                    this.canvas.focus();
                }
            },
            start() {
                let root_ = this;

                BABYLON.Database.IDBStorageEnabled = true;

                
                this.canvas                = document.querySelector("#game");
                //this.engine                = new BABYLON.Engine(this.canvas, true, { preserveDrawingBuffer: true, stencil: true });

                this.engine = new BABYLON.Engine(this.canvas, true);
            
                this.engine.displayLoadingUI();

                this.scene                 = new BABYLON.Scene(this.engine);
                this.scene.clearColor      = new BABYLON.Color3(0.75, 0.75, 0.75);
                this.scene.ambientColor    = new BABYLON.Color3(1, 1, 1);
                this.scene.checkCollisions = false;
                this.scene.collisionsEnabled = false;
                this.scene.gravity         = new BABYLON.Vector3(0, -0.9, 0);
                //this.scene.debugLayer.show({ showExplorer: true, embedMode: true })

                var light = new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(0, 1, 0), this.scene);
                light.intensity = 1;

                var light2 = new BABYLON.DirectionalLight("light2", new BABYLON.Vector3(-1, -1, -1), this.scene);
                light2.position = new BABYLON.Vector3(0, 128, 0);
                light2.intensity = 1;


                //----- terreno -----//
                Materials;
                
                BABYLON.SceneLoader.ImportMesh("", this.$url + "blender/", "scene.babylon", this.scene, function (meshes, particleSystems, skeletons) {
                    meshes, particleSystems, skeletons;


                    /*for (let o in meshes) {
                        console.log(meshes[o].name, meshes[o]);
                    }*/
                    root_.loadBoxColider();
                });
                //----- \\ -----//


                //parameters: alpha, beta, radius, target position, scene
                if (!root_.mobile)
                    this.camera = new BABYLON.ArcRotateCamera("camera", 0, Math.PI / 2, 3, new BABYLON.Vector3(194.04088206947904, 2.060455848812399 -8.7604997265166), this.scene);
                else
                    this.camera = new BABYLON.ArcRotateCamera("camera", 0, Math.PI / 2, 5, new BABYLON.Vector3(0, 0, 0), this.scene);
                this.camera.keysLeft = [];
                this.camera.keysRight = [];
                this.camera.keysUp = [];
                this.camera.keysDown = [];
                this.camera.attachControl(this.canvas, true);
                this.camera.position = new BABYLON.Vector3(194.04088206947904, 2.060455848812399 -12.7604997265166);
                
                //this.camera.lowerRadiusLimit = process.env.NODE_ENV === 'production' ? 3: 0;
                //this.camera.upperRadiusLimit = process.env.NODE_ENV === 'production' ? 10: 10000;

                this.camera.lowerRadiusLimit = !isMobile ? 3 : 4;
                this.camera.upperRadiusLimit = !isMobile ? 3 : 4;


                this.camera.wheelDeltaPercentage = 0.01;
                this.camera.checkCollisions = false;
                this.camera.noRotationConstraint = false;
                //this.camera.collisionRadius = new BABYLON.Vector3(0.5, 0.5, 0.5);
                //this.camera.ignoreParentScaling = false;


                //this.camera.setTarget(BABYLON.Vector3.Zero());

                //girar esquerda(ok)
                //this.camera.lowerAlphaLimit = 0;
                //girar direita(ok)
                //this.camera.upperAlphaLimit = 0;

                this.camera.lowerBetaLimit = 0;
                this.camera.upperBetaLimit = 1.5;//1.5


                //root_.loadScenary();
                this.engine.runRenderLoop(this.listener);
                window.addEventListener("resize", this.resize);
            },
            loadBoxColider() {
                let root_ = this;
                BABYLON.SceneLoader.ImportMesh("", this.$url + "colider/", "AgrinhoBabylon.babylon", this.scene, function (meshes, particleSystems, skeletons) {
                    meshes, particleSystems, skeletons;
                    root_.loadAvatar();
                });
            },
            loadAvatar() {
                let root_ = this;
                BABYLON.SceneLoader.ImportMesh("", this.$url + "players/", this.avatar + ".glb", this.scene, function (meshes, particleSystems, skeletons) {
                    root_.me                    = meshes[0];
                    root_.me.id                 = root_.id;
                    root_.skeleton              = skeletons[0];
                    root_.me.skeleton           = root_.skeleton;
                    //root_.me.position           = new BABYLON.Vector3(103, 0, -73);

                    root_.me.position           = new BABYLON.Vector3(197.6072289582091, 0.21999999567298967, -12.658269757979141);
                    //root_.me.position           = new BABYLON.Vector3(-26.7885787942582, 0.03769999876061059, 51.09103577596679);

                    root_.me.checkCollisions    = false;
                    root_.me.ellipsoid          = new BABYLON.Vector3(0.5, 1, 0.5);
                    root_.me.ellipsoidOffset    = new BABYLON.Vector3(0, 1, 0);
                    //root_.me.scaling            = new BABYLON.Vector3(3, 3, 3);

                    //console.log(root_.me);

                    //glb
                    root_.me.rotationQuaternion = null;
                    
                    let group = root_.scene.animationGroups;
                    let agMap = {
                            fall: group[2],
                            idle: group[0],
                            idleJump: group[1],
                            idleJump2: group[1],
                            run: group[2],
                            runJump: group[1],
                            sit: group[2],
                            slideBack: group[2],
                            strafeLeft: group[2],
                            strafeRight: group[2],
                            turnLeft: group[2],
                            turnRight: group[2],
                            walk: group[2],
                            walkBack: group[2],
                            z: group[2],
                    }
                    
                    root_.cc = new CharacterController(root_.me, root_.camera, root_.scene, agMap);
                    root_.cc.setFaceForward(true);

                    //root_.cc.setWalkSpeed(12);
                    //root_.cc.setBackSpeed(8);
                    //**root_.cc.setRunSpeed(30);

                    root_.cc.setMode(0);
                    root_.cc.setTurningOff(false);
                    root_.cc.setTurnSpeed(45);
                    if (!root_.mobile)
                        root_.cc.setCameraTarget(new BABYLON.Vector3(0, 1, 0));
                    else
                        root_.cc.setCameraTarget(new BABYLON.Vector3(0, 1, 0));
                    root_.cc.setNoFirstPerson(false);
                    root_.cc.setStepOffset(0.4);
                    root_.cc.setSlopeLimit(30, 60);
                    root_.cc.enableKeyBoard(true);
                    root_.cc.start();


                    //root_.engine.hideLoadingUI();
                    root_.loadItens();
                    
                    //connect
                    //root_.$parent.$refs['multiplayer'].connect();
                });
            },



            //----- load -----//
            loadItens(e) {
                if (e) {
                    this.$refs["page"].value = 0;
                    e.preventDefault();
                }
                let form_data = new FormData();
                form_data.append('id_user', this.id);
                axios.get(this.$b + 'api/get-itens?' + new URLSearchParams(form_data).toString()).then(response => this.loadItensResponse(response));
            },
            loadItensResponse(obj) {
                for (let o = 0; o < obj.data.length; o++) {
                    if (!this.itens_preenchidos[obj.data[o]])
                        this.itens_preenchidos[obj.data[o]] = 1;
                    else
                        this.itens_preenchidos[obj.data[o]]++;
                }

                //console.log('this.itens_preenchidos -> ', this.itens_preenchidos);
                this.loadItensGLB();
            },
            //----- -----//


        
            loadItensGLB() {
                //console.log('importM');
                let root_ = this;
                root_;
                
                BABYLON.SceneLoader.ImportMesh("", this.$url + "itens/", "ItensColetaveis.glb", this.scene, function (meshes, particleSystems, skeletons) {
                    meshes, particleSystems, skeletons;

                    root_.itens_meshes = meshes;
                    
                    root_.itens_listener = [];
                    let positions = JSON.parse(JSON.stringify(root_.itens_pos));
                    
                    let n = 0;
                    for (let o = 0; o < meshes.length; o++) {
                        let index = root_.itens_ref.indexOf(meshes[o].name);
                        if (index !== -1) {
                            for (let i = 0; i < (root_.total_itens / root_.itens_unicos); i++) {

                                if ((root_.itens_preenchidos[index] === undefined) || (i >= root_.itens_preenchidos[index])) {

                                    //root_.itens_listener[n] = ((i > 0) ?  meshes[o].clone() : meshes[o]);
                                    meshes[o].position.y = -100;


                                    root_.itens_listener[n] = meshes[o].clone();
                                    root_.itens_listener[n].name = meshes[o].name;
                                    root_.itens_listener[n].checkCollisions = false;

                                    //263.61477252795044, 10.65928437446403, -17.531545867153124
                                    for (let k = positions[index].length - 1; k > 0; k--) {
                                        const j = Math.floor(Math.random() * k);
                                        const temp = positions[index][k];
                                        positions[index][k] = positions[index][j];
                                        positions[index][j] = temp;
                                    }
                            
                                    let pos = positions[index][0];

                                    if ((!root_.fixed_item) && (index == 1) && (i == 0)) {
                                        root_.fixed_item = true;
                                        root_.itens_listener[n].position.x = -263.61477252795044;
                                        root_.itens_listener[n].position.y = 10.5;
                                        root_.itens_listener[n].position.z = -17.531545867153124;
                                    } else {
                                        
                                        root_.itens_listener[n].position.x = -pos[0];
                                        root_.itens_listener[n].position.y = pos[1];
                                        root_.itens_listener[n].position.z = pos[2];
                                    }

                                    if ((root_.itens_listener[n].name == 'Balde') || (root_.itens_listener[n].name == 'PoteDog') || (root_.itens_listener[n].name == 'Pote')) {
                                        root_.itens_listener[n].position.y = pos[1] - 0.2
                                    }
                                    
                                    positions[index].splice(0, 1);

                                    n++;
                                } else {
                                    //meshes[o].dispose();
                                    //root_.scene.removeMesh(meshes[o]);
                                    //meshes[o].material.alpha = 0;
                                    meshes[o].position.y = -100;
                                    //console.log('outside-> ', i, meshes[o].name);

                                }
                            }

                        }
                    }

                    //root_.update_itens_count_day(root_.total_itens - n);

                    //console.log(root_.itens_preenchidos);
                    let count = 0;
                    for (let o in root_.itens_preenchidos) {
                        count += root_.itens_preenchidos[o];
                    }

                    //console.log('count -> ', count);
                    root_.update_itens_count_day(count);

                    window.addEventListener('keydown', root_.keyupHandler);
                    window.addEventListener('keyup', root_.keyupHandler);

                    root_.audioTrilha();
                    root_.$refs['game'].focus();
                    root_.timerStart();


                    //console.log(root_.itens_listener);
                    root_.itensAdicionais();

                    //here
                    if (isMobile) {
                        root_.mobile_controller = true;
                        
                    }   
                        
                    root_.engine.hideLoadingUI();
                });
            },


            //
            //
            //itens aidicionais
            itensAdicionais() {
                //console.log('this.itens_count_day, this.second_level -> ', this.itens_count_day, this.second_level);
                if (this.itens_count_day >= this.second_level) {

                    this.total_itens = 50;
                    //console.log('itensAdicionais()');

                    let p = [
                        [0, 1, 0],
                        [3, 2, 0],
                        [6, 5, 0],
                        [9, 7, 0],
                        [12, 9, 0],
                        [15, 11, 0],
                        [18, 11, 3],
                        [21, 11, 0],
                        [24, 11, -3],
                        [27, 11, 0],
                        [30, 11, 3],
                        [33, 11, 6],
                        [36, 11, 3],
                        [39, 11, 0],
                        [42, 11, 0],
                        [42, 11, -3],
                        [42, 11, -6],
                        [42, 11, -9],
                        [42, 11, -12],
                        [42, 11, -15],
                        [39, 11, -12],
                        [36, 11, -9],
                        [33, 11, -9],
                        [30, 11, -9],
                        [27, 11, -9],
                        [24, 9, -12],
                        [21, 7, -15],
                        [18, 5, -18],
                        [15, 2, -21],
                        [12, 1, -24],
                    ];
                    let box;
                    var mat = new BABYLON.StandardMaterial("mat", this.scene);
                    var texture = new BABYLON.Texture(this.$url + "img/box.jpg", this.scene);
                    mat.diffuseTexture = texture;

                    var columns = 1;
                    var rows = 1;

                    var faceUV = new Array(4);
                    for (var i = 0; i < 1; i++) {
                        faceUV[i] = new BABYLON.Vector4(i / columns, 0, (i + 1) / columns, 1 / rows);
                    }
                    
                    for (let o = 0; o < p.length; o++) {
                        box                 = new BABYLON.MeshBuilder.CreateBox("box_" + o, 
                        {
                            faceUV: faceUV,
                            wrap: false,
                            width: 2,
                            height: ((o == 1) || (o == 28)) ? 4 : 2,
                            depth: 2
                        }, this.scene);

                        box.position        = new BABYLON.Vector3(p[o][0], p[o][1], p[o][2]);
                        box.material        = mat;
                        box.checkCollisions = true;
                    }

                    p = [
                        [15, 11, 0],
                        [18, 11, 3],
                        [21, 11, 0],
                        [24, 11, -3],
                        [27, 11, 0],
                        [30, 11, 3],
                        [33, 11, 6],
                        [36, 11, 3],
                        [39, 11, 0],
                        [42, 11, 0],
                        [42, 11, -3],
                        [42, 11, -6],
                        [42, 11, -9],
                        [42, 11, -12],
                        [42, 11, -15],
                        [39, 11, -12],
                        [36, 11, -9],
                        [33, 11, -9],
                        [30, 11, -9],
                        [27, 11, -9]
                    ]


                    ///let positions = JSON.parse(JSON.stringify(this.itens_pos));
                    let positions = JSON.parse(JSON.stringify(this.itens_fase_2));
                    //console.log('positions -> ', positions);
                    let n = 0;
                    for (let o = 0; o < this.itens_meshes.length; o++) {
                        let index = this.itens_ref.indexOf(this.itens_meshes[o].name);
                        if (index !== -1) {

                            for (let i = 0; i < (20 / this.itens_unicos); i++) {

                                if ((this.itens_preenchidos[index] === undefined) || ((i + 3) >= this.itens_preenchidos[index])) {
                                    this.itens_meshes[o].position.y = -100;
                                    this.itens_listener.push(this.itens_meshes[o].clone());
                                    let index_                                = this.itens_listener.length - 1;
                                    this.itens_listener[index_].         name = this.itens_meshes[o].name;



                                    //if ((n == 4) || (n == 8) || (n == 12) || (n == 16)) {
                                    //if ((n > 0) && (n % 2 == 0)) {
                                    if ((index % 2) == 0) {
                                        //1
                                        this.itens_listener[index_].position.x    = -p[n][0];
                                        
                                        if ((this.itens_listener[index_].name == 'Balde') || (this.itens_listener[index_].name == 'PoteDog') || (this.itens_listener[index_].name == 'Pote')) {
                                            this.itens_listener[index_].position.y = p[n][1] + 0.8;
                                        } else {
                                            this.itens_listener[index_].position.y = p[n][1] + 1;
                                        }
                                        this.itens_listener[index_].position.z = p[n][2];
                                        //

                                    } else {


                                        //00
                                        for (let k = positions[index].length - 1; k > 0; k--) {
                                            const j = Math.floor(Math.random() * k);
                                            const temp = positions[index][k];
                                            positions[index][k] = positions[index][j];
                                            positions[index][j] = temp;
                                        }
                                
                                        let pos = positions[index][0];
                                        
                                        this.itens_listener[index_].position.x = -pos[0];
                                        this.itens_listener[index_].position.y = pos[1];
                                        if ((this.itens_listener[index_].name == 'Balde') || (this.itens_listener[index_].name == 'PoteDog') || (this.itens_listener[index_].name == 'Pote')) {
                                            this.itens_listener[index_].position.y = pos[1] - 0.2
                                        }
                                        this.itens_listener[index_].position.z = pos[2];
                                        positions[index].splice(0, 1);
                                        //


                                    
                                    }



                                    n++;
                                } else {
                                    //this.itens_meshes[o].position.y = -100;
                                }
                            }



                        }
                    }



                }

            },
            //
            //
            //


            //
            //
            //timer
            timerStart() {
                /*
                let root_ = this;
                this.count_timer = 0;
                this.timer = setInterval(function() {
                    if ((root_.count_timer > 0) && ((root_.count_timer % 300) === 0)) {
                        //clearInterval( root_.timer );

                        root_.$parent.itemInfo(root_.itens_listener, root_.total_itens);
                        //root_.$parent.videoInfo(root_.itens_listener, root_.total_itens);
                        root_.count_timer = 0;
                    }
                    root_.count_timer++;
                }, 1000);*/
            },
            //
            //
            //



            keyupHandler(e) {
                //console.log('keyupHandler aham', e.type, document.activeElement.id);

                //console.log('document.activeElement.id -> ', document.activeElement.id);
                if (document.activeElement.id !== 'game') {
                    //document.getElementById('game').click();
                    //document.getElementById('game').focus();


                    var canvasElm = document.getElementById('game');
                    canvasElm.setAttribute('tabindex','0');
                    canvasElm.focus();


                    //console.log('click');
                }
                
               

                /*if (e.type == 'keydown') {
                    let obj = document.getElementById('game');
                    if (obj.hasFocus()) {
                        console.log('focus');
                        document.getElementById('game').focus();
                        document.getElementById('trilha').play();
                    }
                }*/
                
    
                if (e.code == 'Space') {
                    if (e.type == 'keydown')
                    {
                        //aquioi
                        
                        if (!this.jump_active) {
                            this.jump_active = true;
                            document.getElementById('jump').pause();
                            document.getElementById('jump').currentTime = 0;
                            document.getElementById('jump').play();
                        }
                    } else if (e.type == 'keyup') {
                        this.jump_active = false;
                    }
                }
                e.preventDefault();
            },
            exit() {
                if (this.mobile) {
                    //this.left_joy_stick.dispose();
                    //this.right_joy_stick.dispose();


                    //BABYLON.VirtualJoystick.Canvas.style.zIndex = "-1";
                    //document.getElementById("btn-jump").style.zIndex = "-1";
                }
                try { window.removeEventListener('keydown', this.keyupHandler); } catch(e) { e; }
                try { window.removeEventListener('keyup', this.keyupHandler); } catch(e) { e; }
                try { window.removeEventListener("resize", this.resize); } catch(e) { e; }
                try { this.me.dispose(); } catch(e) { e; }
                try { this.skeleton.dispose(); } catch(e) { e; }
                try { this.camera.dispose(); } catch(e) { e; }
                try { this.scene.dispose(); } catch(e) { e; }
                try { this.engine.dispose(); } catch(e) { e; }
                
                //console.log('exit 1');
            }
        },
        mounted() {
            //console.log('this.itens_fase_2 -> ', this.itens_fase_2);
            this.update_mobile(isMobile ? true : false);

            //document.getElementsByTagName('header')[0].style.backgroundColor = 'rgba(255, 255, 255, .1)';
            document.getElementsByTagName('header')[0].style.borderBottom = 'none';
            document.getElementsByClassName('menu-icon')[0].getElementsByTagName('ul')[0].getElementsByTagName('li')[1].style.color = '#fff';
            document.getElementById("logo").style.filter = "brightness(0) invert(1)";
            document.getElementById("logo").addEventListener('click', this.importM);

            if (!this.info_started) {
                /*if (isMobile)
                    this.$parent.view_info_mobile = true;
                else
                    this.$parent.view_info_desktop = true;*/

                this.$parent.view_init = true;

                        
                this.update_info_started(true);
            }

            this.start();
        },
        destroyed() {
           this.exit();
        },

    }
</script>
<style>
html, #btn-jump
{
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}
</style>
<style scoped>
    #game {
        height  : 100%;
        left    : 0;
        margin  : 0;
        overflow: hidden;
        padding : 0;
        position: fixed;
        top     : 0;
        width   : 100%;
        z-index : 0;
        touch-action: none;
        
    }
    #btn-jump {
        bottom: 0;
        right: 10px;
        opacity: 1;
        position: absolute;
    }
</style>
